import script from "./PuzzleVideoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PuzzleVideoCard.vue?vue&type=script&setup=true&lang=ts"

import "./PuzzleVideoCard.vue?vue&type=style&index=0&id=28c55c9a&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c55c9a"]])

export default __exports__